import { Tooltip } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import { Menu } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';

import { colors } from 'theme/color-palette';
import { themedCheckbox } from 'theme/theme';
import { Bogle_Regular } from 'constants/constant';

const { WHITE, BLACK, LIGHT_GREY, LIGHTER_BLACK, TOGGLE_ACTIVE, LIGHT_GRAY_SHADE } = colors;

const useStyle = makeStyles(() => ({
	/* MTS Field */
	MTSFieldContainer: {
		display: 'flex',
		cursor: 'pointer',
		position: 'relative',
		'&:hover': {
			backgroundColor: LIGHT_GRAY_SHADE
		}
	},
	MTSField: {
		padding: 0,
		marginRight: '16px'
	},
	checkBox: themedCheckbox,
	MTSDateIcon: { marginRight: '8px' },
	MTSText: {
		margin: '6px 0 6px 8px',
		'& span': {
			fontSize: '14px'
		}
	},
	MTSPivotIcon: {
		width: 16,
		height: 16,
		padding: 4,
		marginRight: 4,
		borderRadius: '50%',
		'&:hover': {
			backgroundColor: LIGHT_GREY
		}
	},
	MTSFilterIcon: {
		borderRadius: 4,
		'&:hover': {
			backgroundColor: LIGHT_GREY
		}
	},

	/* MTS Filter */
	MTSFilterContainer: {
		margin: '12px 16px 24px',
		display: 'flex',
		flexDirection: 'column',
		gap: '16px'
	},
	MTSFilterContainerCollapsed: {
		padding: '12px 16px 16px',
		display: 'flex',
		flexDirection: 'column',
		gap: '4px',
		cursor: 'pointer',
		'&:hover': {
			backgroundColor: LIGHT_GRAY_SHADE
		},
		'& p:nth-child(2)': {
			fontWeight: 400,
			fontSize: '12px'
		}
	},
	MTSFilterTitleBox: {
		display: 'flex',
		justifyContent: 'space-between'
	},
	MTSFilterDeleteIcon: { cursor: 'pointer' },
	MTSFilterInput: {
		'& label': {
			fontFamily: Bogle_Regular
		},
		'& .MuiChip-label': {
			fontSize: '14px'
		},
		'& .MuiAutocomplete-tag': {
			margin: '4px !important',
			borderRadius: '2px'
		}
	},

	/* MTS Widget */
	MTSWidgetContainer: {
		zIndex: 100,
		top: '214px',
		right: '16px',
		width: '413px',
		position: 'fixed',
		background: WHITE,
		borderRadius: '16px',
		boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.2)'
	},
	MTSWidgetBody: {
		display: 'flex',
		height: '332px'
	},
	MTSWidgetSidePanel: {
		width: '138px',
		display: 'flex',
		flexDirection: 'column',
		'& ul': {
			paddingTop: '16px'
		},
		'& li': {
			minWidth: 'auto !important'
		}
	},
	MTSWidgetSidePanelItem: {
		backgroundColor: WHITE,
		'&:hover': {
			backgroundColor: 'rgba(0, 0, 0, .05)'
		}
	},
	MTSWidgetSidePanelItemSelected: {
		backgroundColor: TOGGLE_ACTIVE,
		'&:hover': {
			backgroundColor: '#DFDCE7'
		}
	},
	MTSWidgetSidePanelText: {
		margin: 0,
		'& span': {
			fontSize: 14,
			color: LIGHTER_BLACK
		}
	},
	verticalDivider: {
		width: 1,
		backgroundColor: LIGHT_GREY
	},
	MTSWidgetMainPanel: {
		width: '100%',
		padding: '16px 0'
	},
	subMenuItem: {
		height: '32px',
		'& span': {
			fontFamily: Bogle_Regular,
			fontSize: '14px'
		}
	},
	subMenuItemCheckBox: {
		padding: 0,
		marginRight: '8px',
		transform: 'scale(1.1)'
	},
	subMenuItemDisabledCheckBox: {
		padding: 0,
		width: '20px',
		height: '20px',
		borderRadius: 2,
		marginLeft: '2px',
		marginRight: '10px',
		transform: 'scale(1.1)',
		backgroundColor: '#D5D6D8 !important',
		'& svg': {
			visibility: 'hidden'
		}
	},
	MTSWidgetFooter: {
		display: 'flex',
		flexDirection: 'column'
	},
	MTSWidgetInfo: {
		fontSize: 12,
		padding: '8px 16px'
	},
	MTSWidgetAction: {
		padding: 12,
		display: 'flex'
	},
	/* common - Widget & Filter */
	clearAllBtn: {
		'& span': {
			fontWeight: 700,
			fontSize: '14px',
			color: LIGHTER_BLACK
		},
		'&:hover': {
			backgroundColor: WHITE
		}
	},
	clearAllDisabledBtn: {
		'& span': {
			color: '#BABBBE'
		}
	},
	MTSActionRight: {
		marginLeft: 'auto',
		display: 'flex',
		gap: '8px'
	},
	MTSActionBtn: {
		borderRadius: 100,
		padding: '6px 16px',
		'& span': {
			fontSize: '14px',
			fontWeight: 700
		}
	},
	MTSSecondaryBtn: {
		border: '1px solid #D5D6D8'
	},
	MTSPrimaryBtn: {
		backgroundColor: '#6245B7',
		'&:hover': {
			backgroundColor: '#6245B7'
		},
		'& span': {
			color: WHITE
		}
	},

	/* MTS Custom range */
	MTSCustomContainer: {
		margin: '0 16px',
		display: 'flex',
		flexDirection: 'column',
		gap: '16px'
	},
	MTSCustomRangeInputBox: {
		borderRadius: 4,
		padding: '10px 8px',
		border: '1px solid #E3E4E5',
		'& p': {
			color: '#74767C',
			fontSize: '14px'
		},
		'&-disabled': {
			borderRadius: 4,
			padding: '10px 8px',
			border: '1px solid #D5D6D8',
			backgroundColor: '#F1F1F2',
			'& p': {
				color: '#BABBBE',
				fontSize: '14px'
			}
		},
		'&:hover': {
			backgroundColor: '#F8F8F8',
			border: '1px solid #909196'
		}
	},
	MTSInputLabelBox: {
		display: 'flex',
		cursor: 'default',
		alignItems: 'center',
		justifyContent: 'space-between'
	},
	InputIcon: {
		color: '#74767C',
		cursor: 'pointer'
	},
	MTSTimeRangeInputBox: {
		marginTop: '8px',
		display: 'flex',
		gap: '8px'
	},
	MTSTimeRangeInput: {
		height: '32px',
		fontSize: '12px',
		fontFamily: Bogle_Regular,
		'& input': {
			width: '80px',
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis',
			color: 'transparent',
			textShadow: `0 0 0 ${BLACK}`
		}
	}
}));

/* Tooltip */
export const CustomizedTooltip = withStyles({
	tooltip: {
		color: BLACK,
		backgroundColor: WHITE,
		width: '235px',
		padding: '16px',
		boxShadow: '0px -1px 4px 0px rgba(0, 0, 0, 0.10), 0px 5px 10px 3px rgba(0, 0, 0, 0.15)',
		fontFamily: Bogle_Regular,
		fontSize: '12px',
		lineHeight: '16px'
	},
	arrow: {
		color: WHITE
	}
})(Tooltip);

/* MTS Custom range */
export const CustomInputMenu = styled((props) => (
	<Menu
		elevation={0}
		anchorOrigin={{
			vertical: 'bottom',
			horizontal: 'left'
		}}
		{...props}
	/>
))(() => ({
	'& .MuiPaper-root': {
		width: '88px',
		borderRadius: 4,
		marginTop: '42px',
		boxShadow: '0px 5px 10px 3px #00000026, 0px -1px 4px 0px #0000001A',
		'& .MuiMenuItem-root': {
			'&:active': {
				backgroundColor: '#F8F8F8'
			}
		}
	},
	'& ul': {
		padding: 0
	},
	'& li': {
		padding: '8px 16px',
		fontSize: '14px',
		fontFamily: Bogle_Regular
	}
}));

export default useStyle;
